module.exports = __webpack_public_path__ + "static/media/BannerTop.63816f92.png";